import type { ReactNode } from 'react';
import { useId } from 'react';

export const LinearSuggestionsGroup = ({
  heading,
  children,
}: {
  heading: ReactNode;
  children: ReactNode;
}) => {
  const headingId = useId();

  return (
    <>
      <div id={headingId} className="bg-color-grey p-1">
        <div className="mt-0.5 mr-4 mb-1 ml-1 font-semibold">{heading}</div>
      </div>
      <ul role="menu" aria-labelledby={headingId} className="m-0 list-none p-0">
        {children}
      </ul>
    </>
  );
};
